module.exports = __webpack_public_path__ + "img/securitydetailsList2.947317d5.png";